module.exports = __webpack_public_path__ + "img/192.9abcf825.jpg";